import { EstimateStatus } from '../types';

/**
 * utils/estimateEditability.ts — UNA sola definición de «este estimado ya está
 * cerrado».
 *
 * POR QUÉ EXISTE (PLAN-pricing-model-v2, decisión 7 y ola 4). La regla ya vivía
 * escrita en `components/estimate/EstimatePricingSnapshotPanel.tsx` como
 * `canRefresh`, y la ola 4 necesita la MISMA regla en tres sitios más: el
 * deslizador de margen neto, el panel de política de precios y la puerta de
 * `useEstimateForm` que impide que una fila cambie de precio. Escribirla cuatro
 * veces es cómo se acaba con cuatro respuestas distintas a la pregunta «¿puedo
 * tocar este precio?» — que es exactamente el patrón que este plan existe para
 * corregir en la aritmética del dinero.
 *
 * QUÉ DICE. Un estimado en Sent / Accepted / Declined / Expired / Completed /
 * Paid / Archived es un documento que un cliente YA VIO: sus precios quedan como
 * los vio. Solo Draft y «Review Needed» siguen siendo borradores.
 *
 * EL CASO SIN ESTADO. Un estimado que todavía se está armando en memoria puede
 * llegar sin `status` —lo hacen varias pruebas y algún camino de creación—, y
 * ahí la respuesta correcta es SÍ: nadie lo ha visto todavía. Devolver `false`
 * por omisión convertiría «no lo sé» en «está cerrado» y dejaría el constructor
 * de solo lectura antes de existir el documento.
 */
export const canEditPricing = (status?: EstimateStatus | string | null): boolean => {
    if (status === undefined || status === null || status === '') return true;
    return status === EstimateStatus.DRAFT || status === EstimateStatus.REVIEW_NEEDED;
};
